import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Particle from "../Particle";
import pdf from "../../Assets/Pranav_Aggarwal_Resume.pdf";
import { AiOutlineDownload, AiOutlineFilePdf, AiOutlineZoomIn, AiOutlineZoomOut } from "react-icons/ai";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

function ResumeNew() {
  const [pageWidth, setPageWidth] = useState(1200);
  const [numPages, setNumPages] = useState(null);
  const [scale, setScale] = useState(1);

  useEffect(() => {
    function handleResize() {
      const resumeSection = document.querySelector('.resume-section');
      if (resumeSection) {
        setPageWidth(resumeSection.offsetWidth * 0.8);
      }
    }
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const zoomIn = () => setScale(prevScale => Math.min(prevScale + 0.1, 2));
  const zoomOut = () => setScale(prevScale => Math.max(prevScale - 0.1, 0.5));

  return (
    <div className="resume-background">
      <Container fluid className="resume-section">
        <Particle />
        <Row className="resume-content">
          <Col md={12} className="resume-header">
            <h1 style={{ fontSize: "2.6em", paddingBottom: "20px" }}>
              My <strong className="purple">Resume</strong>
            </h1>
          </Col>
          <Col md={12} className="resume-btn-container">
            <Button
              variant="primary"
              href={pdf}
              download="Pranav_Aggarwal_Resume.pdf"
              style={{ maxWidth: "250px" }}
              className="resume-btn"
            >
              <AiOutlineDownload /> Download CV
            </Button>
            <Button onClick={zoomIn} className="resume-btn mx-2">
              <AiOutlineZoomIn /> Zoom In
            </Button>
            <Button onClick={zoomOut} className="resume-btn">
              <AiOutlineZoomOut /> Zoom Out
            </Button>
          </Col>
          <Col md={12} className="resume-view">
            <Document 
              file={pdf} 
              onLoadSuccess={onDocumentLoadSuccess}
              className="d-flex flex-column align-items-center"
            >
              {Array.from(new Array(numPages), (el, index) => (
                <Page
                  key={`page_${index + 1}`}
                  pageNumber={index + 1}
                  width={pageWidth * scale}
                  className="resume-page"
                />
              ))}
            </Document>
          </Col>
          <Col md={12} className="resume-btn-container">
            <Button
              variant="primary"
              href={pdf}
              target="_blank"
              style={{ maxWidth: "250px" }}
              className="resume-btn"
            >
              <AiOutlineFilePdf /> View Full PDF
            </Button>
          </Col>
        </Row>
      </Container>
      <style>{`
        .resume-background {
          background-color: #1a1a1a;
          min-height: 100vh;
        }
        .resume-section {
          position: relative;
          padding-top: 110px !important;
          padding-bottom: 30px !important;
          color: white;
        }
        .resume-content {
          padding: 20px;
          background-color: rgba(255, 255, 255, 0.05);
          border-radius: 15px;
          backdrop-filter: blur(10px);
        }
        .resume-header {
          text-align: center;
          padding-bottom: 30px;
        }
        .purple {
          color: #c770f0;
        }
        .resume-btn-container {
          display: flex;
          justify-content: center;
          margin: 20px 0;
        }
        .resume-btn {
          padding: 10px 20px;
          font-size: 1.2em;
          transition: all 0.3s ease-in-out;
          background-color: #623686;
          border: none;
        }
        .resume-btn:hover {
          transform: translateY(-3px);
          box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
          background-color: #6d20c5d7;
        }
        .resume-view {
          display: flex;
          justify-content: center;
          margin-top: 30px;
        }
        .resume-page {
          margin-bottom: 20px;
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
        }
      `}</style>
    </div>
  );
}

export default ResumeNew;